import { ATTRIBUTE_TYPE } from '@web-platform/shared-universal-constants/src/filterAttributes';
import { stringArrayMatch } from '@web-platform/shared-universal-utils-frontend/src/helpers/stringArrayMatch';

import type { AttributeType } from '@web-platform/shared-universal-constants/src/filterAttributes';
import type {
  AttributeOptionIdLookup,
  FilterStatusMap,
} from '@web-platform/shared-universal-types/src/redux/state/entities/flights/itineraries';

// since we only have 2 supported attributes we just hardcode the combinations, could be calculated dynamically if/when we support more
const availableAttributes = [ATTRIBUTE_TYPE.CABIN_BAGGAGE, ATTRIBUTE_TYPE.CHECKED_BAGGAGE];
const attributeCombinations = [
  [],
  [ATTRIBUTE_TYPE.CABIN_BAGGAGE],
  [ATTRIBUTE_TYPE.CHECKED_BAGGAGE],
  [ATTRIBUTE_TYPE.CABIN_BAGGAGE, ATTRIBUTE_TYPE.CHECKED_BAGGAGE],
];

const hasOptionsForAttributes = (
  attributeOptionIdLookup: AttributeOptionIdLookup[],
  attributes: AttributeType[],
) => {
  const match = attributeOptionIdLookup.find((entry) =>
    stringArrayMatch(entry.attributes, attributes),
  );
  return match && match.optionIds.length > 0;
};

const getAvailableAttributes = (
  selectedAttributes: AttributeType[],
  attributeOptionIdLookup: AttributeOptionIdLookup[],
): AttributeType[] =>
  availableAttributes.filter((attribute) => {
    if (selectedAttributes.includes(attribute)) {
      return true; // always enable a selected attribute
    }

    // test if adding a given attribute onto the currently selected attributes would yield some optionIds
    //  if so we can enable it, otherwise it should not be enabled
    const toCheck = [...selectedAttributes, attribute];
    return hasOptionsForAttributes(attributeOptionIdLookup, toCheck);
  });

export const createFilterStatusMap = (
  attributeOptionIdLookup: AttributeOptionIdLookup[],
): FilterStatusMap[] =>
  attributeCombinations
    .filter((selectedAttributeCombination) => {
      const isEmptySelection = !selectedAttributeCombination.length;
      if (isEmptySelection) {
        return true; // always calculate available attributes for empty selection
      }

      // we don't want to calculate the available attributes for selection combinations that can't actually happen
      return hasOptionsForAttributes(attributeOptionIdLookup, selectedAttributeCombination);
    })
    .map((selectedAttributeCombination) => ({
      selectedAttributes: selectedAttributeCombination,
      availableAttributes: getAvailableAttributes(
        selectedAttributeCombination,
        attributeOptionIdLookup,
      ),
    }));
